// Values match the whatsappMeta.phoneState locale keys.
export enum WhatsAppPhoneState {
    OPERATING = 'operating',
    NOT_ENABLED = 'notEnabled',
    AWAITING_META = 'awaitingMeta',
    INACTIVE = 'inactive',
    UNKNOWN = 'unknown',
}
